import { Box, Button, Typography } from '@mui/material';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import type Enums from '@core/types/api/Enums';

import { Page } from '../../components/Page/Page';
import { getPermissionLabel } from './utils/getPermissionLabel';

interface PermissionDeniedPageProps {
  permissions: Enums.Permission[];
}

export const PermissionDeniedPage: FC<PermissionDeniedPageProps> = ({ permissions }) => {
  const navigate = useNavigate();

  return (
    <Page title='No Permission'>
      <Box
        sx={{
          height: '70vh',
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
          }}
          variant='h2'
        >
          You don’t have permission to view this section
        </Typography>

        <Typography variant='body1'>
          Please contact your administrator to request access to the{' '}
          <Typography
            component='span'
            sx={{
              fontWeight: 600,
            }}
          >
            {permissions.map((p) => `"${getPermissionLabel(p)}"`).join(', ')}
          </Typography>
        </Typography>

        <Button variant='slab-primary' onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </Box>
    </Page>
  );
};
